import type { MouseEvent } from "react";
import { DocumentPreviewIcon } from "@/icons/widget-menu";
import type { ActiveSubMenuState, MenuOptionResult, SetActiveSubMenu } from "../../types";
import styles from "../../WidgetMenu.module.css";

interface UseDocumentPreviewPageButtonProps {
    activeSubMenu: ActiveSubMenuState | null;
    setActiveSubMenu: SetActiveSubMenu;
}

export function useDocumentPreviewPageButton({
    activeSubMenu,
    setActiveSubMenu,
}: UseDocumentPreviewPageButtonProps): MenuOptionResult {
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        const button = event.currentTarget;

        setActiveSubMenu((prev) =>
            prev?.name === "documentPreviewPage"
                ? null
                : { name: "documentPreviewPage", anchor: button },
        );
    };

    const isActive = activeSubMenu?.name === "documentPreviewPage";

    return {
        content: <DocumentPreviewIcon className={isActive ? styles.svgStrokeActive : ""} />,
        handleClick,
        isActive,
    };
}
